<template>
    <div v-if="isOpen">
        <DisablePaymentPopup
            v-if="disablePayment === '1'"
            @popup-opened="closeDisablePaymentPopup"
            :stub-text="stubText"/>
        <div v-else class="np-form">
            <div class="np-form__form">
                <div class="np-form__container">
                    <div class="np-form__form-title">
                        {{ indexTitle }}
                        <div class="np-form__form-close-btn"
                            @click="closePopup"></div>
                    </div>
                    <div class="np-form__form-step">
                        <div class="np-form__form-step-title">
                            {{ this.currentService != '' ? titleForSelectedService : currentTitle }}
                        </div>
                        <div class="np-form__form-step-current">
                            Шаг {{ currentStep }} из 4
                        </div>
                    </div>
                    <div
                        :class="[
                            'np-form__type-description',
                            {
                                '__form-steps': currentStep === 2 || currentStep === 3
                            }
                        ]"
                        v-if="currentStep !== 4">
                        <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M22 2.5H2L2 5.87498H22V2.5ZM2 15.5L2 7.87498H22V15.5H2ZM2 0.5C0.895431 0.5 0 1.39543 0 2.5V15.5C0 16.6046 0.89543 17.5 2 17.5H22C23.1046 17.5 24 16.6046 24 15.5V2.5C24 1.39543 23.1046 0.5 22 0.5H2ZM5.45459 11.1875C4.90231 11.1875 4.45459 11.6352 4.45459 12.1875C4.45459 12.7398 4.90231 13.1875 5.45459 13.1875H8.13058C8.68286 13.1875 9.13058 12.7398 9.13058 12.1875C9.13058 11.6352 8.68286 11.1875 8.13058 11.1875H5.45459Z" fill="#00ABAA"/>
                        </svg>
                        <div class="np-form__type-description-text">
                            Оплата банковской картой
                        </div>
                    </div>
                    <div class="np-form__form-steps">
                        <div class="np-form__form-steps-content">
                            <template v-if="currentStep === 1">
                                <new-payment-form-services
                                    :stepOneData="stepOneData"
                                    @select-service="selectedService"
                                    @closePopup="closePopup"
                                />
                            </template>
                            <template
                                v-if="currentStep === 2"
                            >
                                <new-payment-form-user-fields
                                    :formType="formType"
                                    @check-valid="checkValid"
                                    ref="step2"
                                    :userInfo="form.userInfo"
                                />
                            </template>
                            <template
                                v-if="currentStep === 3"
                            >
                                <new-payment-form-contacts-fields
                                    @check-valid="checkValid"
                                    ref="step3"
                                    :contactsInfo="form.contactsInfo"
                                    :formType="formType"
                                />
                            </template>
                            <template
                                v-if="currentStep === 4"
                            >
                                <new-payment-form-final
                                    ref="step4"
                                    :form="this.form"
                                    :formType="formType"
                                    @submit-form="onSubmit"
                                    :error="error"
                                />
                            </template>
                        </div>
                    </div>
                    <div
                        v-if="isShowButtons && (currentStep !== 1 || isServiceAdult)"
                        class="np-form__form-buttons"
                    >
                        <div
                            :class="[
                                'np-form__form-buttons-button __prev',
                                {'__disabled': (currentStep === minStep) && !isServiceAdult}
                            ]"
                            @click="prevStep"
                        >
                            Назад
                        </div>
                        <div :class="[
                            'np-form__form-buttons-button __next',
                            {'__disabled': isNextButtonDisabled }
                        ]"
                            v-if="currentStep !== 4"
                            @click="nextStep"
                        >
                            Продолжить
                        </div>
                    </div>
                </div>
                <div class="np-form__loading" v-show="preloader">
                    <preloader
                        :show="preloader"
                    />
                </div>
            </div>
            <popup-overlay
                :on="isOpen"
                @closePopup="closePopup"
            />
        </div>
    </div>
</template>
<script>
import PopupOverlay from "@/components/PopupOverlay";
import Preloader from "@/components/Preloader";
import NewPaymentFormServices from "@/components/new-payment-form/NewPaymentFormServices";
import NewPaymentFormUserFields from "@/components/new-payment-form/NewPaymentFormUserFields";
import NewPaymentFormFieldCheckbox from "@/components/new-payment-form/NewPaymentFormFieldCheckbox";
import NewPaymentFormContactsFields from "@/components/new-payment-form/NewPaymentFormContactsFields";
import NewPaymentFormFinal from "@/components/new-payment-form/NewPaymentFormFinal";
import formData from "@/assets/js/_formData";
import DisablePaymentPopup from '@/components/DisablePaymentPopup.vue'
import axios from "axios";

export default {
    name: 'new-payment-form',
    components: {
        NewPaymentFormFinal,
        NewPaymentFormUserFields,
        PopupOverlay,
        NewPaymentFormServices,
        NewPaymentFormFieldCheckbox,
        NewPaymentFormContactsFields,
        Preloader,
        DisablePaymentPopup
    },
    props: {
        servicesList: {
            type: Array,
            default: [
                {
                    id: '1221',
                    name: 'Оплата услуг скорой помощи'
                },
                {
                    id: '866',
                    name: 'Пополнение депозита (VIP договор)'
                },
                {
                    id: '869',
                    name: 'Оплата разовых услуг'
                }]
        },
        hospitals: {
            type: Array
        },
        clinics: {
            type: Array
        },
        constData: {
            type: Object,
        },
        isDisabledInsideOpen: {
            default: false
        },
        isPopup: {},
        currentService: {
            type: String,
            default: ''
        },
        disablePayment: {
            type: String,
            default: '0'
        },
        stubText: {
            type: String,
            default: '<div>Оплата временно недоступна</div>'
        },
    },
    data() {
        return {
            isOpen: false,
            isShowButtons: true,
            isNextButtonDisabled: true,
            form: {
                service: '',
            },
            currentStep: 1,
            minStep: 1,
            indexTitle: 'Оплата услуги',
            currentTitle: 'Выберите услугу: ',
            formType: 'default',
            stepOneData: [],
            stepOneDataType: 'service',
            preloader: false,
            error: false
        }
    },
    methods: {
        copyObject(object) {
            let copiedObj = {};

            for (let key in object) {
                copiedObj[key] = object[key];
            }

            return copiedObj;
        },
        closePopup() {
            this.isOpen = false;
        },
        openPopup(type) {
            this.isOpen = true;
            this.clearForm();
            if (type === 'program') {
                this.minStep = 2;
                this.currentStep = 2;
                this.currentTitle = this.form.service.name ? this.form.service.name : '';
            }
            this.changeTitles();
        },
        openInside(e) {
            if (e.target.classList.contains('vue-open-payment-popup')) {
                e.target.classList.contains('__pnd-popup') ?
                    this.formType = 'pnd' :
                    this.formType = 'default'
                this.isOpen = true;
                this.clearForm();
                this.currentService ? this.currentStep = 2 : this.currentStep = 1;
                this.stepOneData = this.servicesList;
                this.changeTitles();
                this.stepOneDataType = 'service';
            }
            else if (e.target.classList.contains('vue-open-payment-popup--hospitals')) {
                this.formType = 'hospitals';
                this.stepOneDataType = 'clinics';
                this.isOpen = true;
                this.clearForm();
                this.currentStep = 1;
                this.stepOneData = this.hospitals;
                this.changeTitles();
            }
        },
        pageScroll(value) {
            !value ?
                document.querySelector('body').classList.add('__no-scroll') :
                document.querySelector('body').classList.remove('__no-scroll');
        },
        selectedService(selectedItem) {
            this.stepOneDataType === 'service' ?
                this.form.service = selectedItem :
                this.form.clinic = selectedItem
            if (selectedItem.id === 867) {
                this.stepOneDataType = 'clinics';
                this.stepOneData = this.clinics;
                this.currentTitle = 'Выберите клинику: ';
            }
            else {
                this.currentStep += 1;
                this.currentTitle = this.formType !== 'hospitals' ? this.form.service.name : 'Оплата госпитализации';
                this.changeTitles()
            }
        },
        clearForm() {
            this.constData ? this.form = this.copyObject(this.constData) : this.form = {service: ''};
            this.currentTitle = 'Выберите услугу: ';
        },
        nextStep() {
            switch (this.currentStep) {
                case 2:
                    this.form.userInfo = this.$refs.step2.nextStep()
                    this.currentStep = 3;
                    this.indexTitle = 'Контакты и сумма к оплате';
                    break
                case 3:
                    this.form.contactsInfo = this.$refs.step3.nextStep()
                    this.currentStep = 4;
                    this.indexTitle = 'Все верно?';
                    break
            }
            this.triggerValid();
        },
        prevStep() {
            if (this.isServiceAdult) {
                this.stepOneData = this.servicesList;
                this.stepOneDataType = 'service';
                this.changeTitles();
            }
            else {
                this.currentStep += -1;
                this.changeTitles();
            }
            this.currentStep < this.minStep ? this.currentStep = this.minStep : '';
            this.triggerValid();
        },
        checkValid(data) {
            this.isNextButtonDisabled = !data.valid;
        },
        secondUserFields() {
            return this.form.userInfo.confirmation || !this.form.userInfo.paymentForAnotherPatient
        },
        onSubmit() {
            const request = formData({
                IBLOCK_ID: '91',
                SELECT_SERVICE:  this.formType === 'hospitals' ? 'hospitalization' : this.form.service.id,
                CLINIC_CODE: this.currentClinic && this.currentService != '' ? this.currentClinic.clinicCode : this.form.clinic ? this.form.clinic.code : '',
                CLINIC_NAME: this.currentClinic && this.currentService != '' ? this.currentClinic.name : this.form.clinic ? this.form.clinic.name : '',
                UNAME: this.form.userInfo.firstName,
                SURNAME: this.form.userInfo.lastName,
                MIDDLENAME: this.form.userInfo.patronymic,
                BIRTHDAY: this.form.userInfo.birthday,
                PATIENT_CHECK: !this.form.userInfo.confirmation || this.form.userInfo.paymentForAnotherPatient ? 'N' : 'Y',
                PNAME: !this.form.userInfo.confirmation || this.form.userInfo.paymentForAnotherPatient ?
                    this.form.userInfo.patient.firstName :
                    '',
                PSURNAME: !this.form.userInfo.confirmation || this.form.userInfo.paymentForAnotherPatient ?
                    this.form.userInfo.patient.lastName :
                    '',
                PMIDDLENAME: !this.form.userInfo.confirmation || this.form.userInfo.paymentForAnotherPatient ?
                    this.form.userInfo.patient.patronymic :
                    '',
                PBIRTHDAY: !this.form.userInfo.confirmation || this.form.userInfo.paymentForAnotherPatient ?
                    this.form.userInfo.patient.birthday :
                    '',
                EMAIL: this.form.contactsInfo.email,
                PHONE: this.form.contactsInfo.phone,
                ADDRESS: this.form.contactsInfo.address ? this.form.contactsInfo.address : '',
                PAY_NUMBER: this.form.contactsInfo.account ? this.form.contactsInfo.account :  '',
                CONTRACT_NUMBER: this.form.contactsInfo.contract ? this.form.contactsInfo.contract : '',
                COST: this.form.contactsInfo.paymentAmount,
                IS_POPUP_SERVICE: this.isPopup ? this.isPopup : 'Y'
            });
            this.preloader = true;

            axios({
                url: '/local/modules/accord.sberbank/handlers/dcpnd.php',
                method: 'post',
                data: request,
                headers: {'Content-Type': 'multipart/form-data'}
            }).then(response => {
                const {data} = response;

                setTimeout(() => {
                    this.preloader = false;
                }, 200)

                if (data.frameUrl) {
                    window.location = data.frameUrl;
                } else if (data.error) {
                    this.error = data.error;
                } else {
                    this.error = data;
                }
            }).catch(error => {
                setTimeout(() => {
                    this.preloader = false;
                }, 200)
                this.error = error;
            }).then(() => {
                setTimeout(() => {
                    this.error = false;
                }, 10000);
            });
        },
        changeTitles() {
            switch (this.currentStep) {
                case 1:
                    if (this.formType === 'hospitals') {
                        this.currentTitle = 'Оплата госпитализации';
                        this.indexTitle = 'Выберите стационар';
                    }
                    else {
                        this.indexTitle = 'Оплата услуги';
                        this.currentTitle = 'Выберите услугу: '
                    }
                    break;
                case 2:
                    this.indexTitle = 'Укажите плательщика';
                    break
                case 3:
                    this.indexTitle = 'Контакты и сумма к оплате';
                    break
            }
        },
        triggerValid() {
            setTimeout(() => {
                switch (this.currentStep) {
                    case 1:
                        this.isNextButtonDisabled = true;
                        break;
                    case 2:
                        this.isNextButtonDisabled = !this.$refs.step2.isValid();
                        break;
                    case 3:
                        this.isNextButtonDisabled = !this.$refs.step3.isValid();
                        break;
                }
            }, 150)
        },
        closeDisablePaymentPopup(data) {
            this.isOpen = data;
        }
    },
    computed: {
        isServiceAdult() {
            return this.form.service && (this.stepOneDataType === 'clinics') && this.currentStep === 1 // если выбрана услуга взрослых, то добавляется выбор клиники и нужна возможность уйти назад
        },
        titleForSelectedService() {
            if (this.currentService != '') {

                let service = '';
                for(let i of this.servicesList) {
                    if(i.id == this.currentService) {
                        service = i.name
                    }
                }
                return service
            }
        },
    },
    mounted() {
        this.pageScroll(!this.isOpen);
        if (!this.isDisabledInsideOpen) {
            document.onclick = (e) => {
                this.openInside(e);
            };
        }
    },
    watch: {
        isOpen: function() {
            this.pageScroll(!this.isOpen); // убираем скролл страницы, если попап открыт
        },
    },
}

</script>
<style lang="scss">
@import '../../assets/scss/mixins-and-vars';

$parent: '.np-form';

#{$parent} {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    color: #333;
    font-family: 'HelveticaNeueCyr', 'Helvetica Neue', Arial, sans-serif !important;
    z-index: 1000;

    ::-webkit-scrollbar { width: 5px; height: 3px;}
    ::-webkit-scrollbar-track { background-color: rgba(206, 64, 10, 0);}
    ::-webkit-scrollbar-track-piece { background-color: rgba(237, 202, 27, 0);}
    ::-webkit-scrollbar-thumb { height: 15px; background-color: #dedede; border-radius: 3px;}

    &__container {
        display: flex;
        flex-direction: column;
        padding: 20px;
        overflow: auto;

        @include mobile {
            padding: 15px 10px;
        }
    }

    &__loading {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
    }

    &__type-description {
        display: flex;
        align-items: center;
        padding: 16px 24px;
        margin-bottom: 15px;
        border-radius: 16px;
        background: #FAF9F8;

        &.__form-steps {
            margin-bottom: 24px;
        }

        &.__last-step {
            margin-top: 15px;
            margin-bottom: 15px;
        }

        &-text {
            margin-left: 10px;
            font-weight: 400;
            font-size: 14px;
        }
    }

    &__form {
        display: flex;
        flex-direction: column;
        position: absolute;
        max-width: 600px;
        max-height: calc(100% - 30px);
        width: 100%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 28px;
        background: #fff;
        border-radius: 20px;
        z-index: 2;
        animation: easeOpen .15s ease-in-out;
        overflow: auto;
        overscroll-behavior: none;

        @include mobile {
            width: calc(100% - 30px);
            transform: translate(calc(-50% - 10px), -50%);
            padding: 10px;
            margin: 0 10px;
        }

        &-title {
            position: relative;
            font-weight: 700;
            font-size: 24px;
            line-height: 24px;
            margin-right: 25px;

            @include mobile {
                font-size: 22px;
            }
        }

        &-close-btn {
            position: absolute;
            right: -21px;
            top: 50%;
            transform: translateY(-50%);
            height: 19px;
            width: 19px;
            cursor: pointer;
            background: #fff;

            &::before,
            &::after {
                position: absolute;
                display: block;
                content: '';
                top: 50%;
                left: 50%;
                width: 26px;
                height: 1px;
                background: #6c6c6c;
            }

            &::after {
                transform: translate(-50%, -50%) rotate(45deg);
            }
            &::before {
                transform: translate(-50%, -50%) rotate(-45deg);
            }
        }

        &-step {
            display: flex;
            justify-content: space-between;
            padding: 32px 0 25px;
            font-size: 16px;

            @include mobile {
                padding: 20px 0 15px;
                font-size: 14px;
            }

            &-title {
                font-weight: 400;
                line-height: 22px;
                padding-right: 10px;
            }

            &-current {
                min-width: 81px;
                color: #7D7987;
            }
        }

        &-buttons {
            display: flex;
            margin-top: 25px;

            @include mobile {
                margin-top: 15px;
            }

            &-button {
                display: flex;
                align-items: center;
                padding: 12px 50px;
                border-radius: 7px;
                font-weight: 600;
                font-size: 16px;
                transition: $transition;
                cursor: pointer;
                user-select: none;

                @include mobile {
                    padding: 8px 20px;
                    font-size: 14px;
                }

                &.__disabled {
                    pointer-events: none;
                    opacity: .4;
                }

                &.__hide {
                    display: none;
                }

                &.__prev {
                    color: $color-brand;
                    border: 1px solid rgba(0, 171, 170, .2);

                    &:hover {
                        background: $color-brand;
                        color: #fff;
                    }
                }

                &.__next {
                    margin-left: 12px;
                    background: $color-brand;
                    color: #fff;

                    @include mobile {
                        flex-direction: column;
                        margin-left: 12px;
                    }

                    &:hover {
                        background : $color-brand-hover;
                    }
                }
            }
        }
    }

    @keyframes easeOpen {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
}

body.__no-scroll {
    position: relative;
    height: 100%;
    overflow: hidden;
    touch-action: none;
    -ms-touch-action: none;
}

.bx-ios body.__no-scroll {
    position: fixed;
    touch-action: none;
    -ms-touch-action: none;
    height: 100%;
}

</style>ы
